"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var ServiceAddress_service_1 = require("./ServiceAddress.service");
var getParsedJwt_1 = require("../../util/getParsedJwt");
var BaseUserService_1 = require("./BaseUserService");
var typedi_1 = require("typedi");
var Url_service_1 = require("./Url.service");
var Crypto_service_1 = require("./Crypto.service");
var bufferToBase64UrlEncoded_1 = require("../../util/bufferToBase64UrlEncoded");
var Http_service_1 = require("./http/Http.service");
var LocalStorage_service_1 = require("./storage/LocalStorage.service");
var rxjs_1 = require("rxjs");
var CODE_VERIFIER_LOCAL_STORAGE_KEY = 'codeVerifier';
var ACCESS_TOKEN_STORAGE_KEY = 'authServiceAccessToken';
var AuthService = /** @class */ (function () {
    function AuthService(sdsService, userService, urlService, cryptoService, httpService, localStorageService) {
        var _this = this;
        this.sdsService = sdsService;
        this.userService = userService;
        this.urlService = urlService;
        this.cryptoService = cryptoService;
        this.httpService = httpService;
        this.localStorageService = localStorageService;
        this.onTokenGrantedSubject = new rxjs_1.ReplaySubject(1);
        this.onTokenGranted = this.onTokenGrantedSubject.asObservable();
        var _a = urlService.getUrlParametersAsObject(), code = _a.code, session_state = _a.session_state;
        if (code && session_state) {
            try {
                var instance = typedi_1.Container.get('instance');
                instance.onTenantSet.subscribe(function () {
                    _this.getToken(code, "" + location.origin + location.pathname);
                });
            }
            catch (ex) {
                console.info(ex);
            }
        }
        if (localStorageService.getItem(ACCESS_TOKEN_STORAGE_KEY)) {
            this.token = localStorageService.getItem(ACCESS_TOKEN_STORAGE_KEY);
            localStorageService.removeItem(ACCESS_TOKEN_STORAGE_KEY);
        }
        if (this.token) {
            // this.userService.setAccessToken(`Bearer ${this.token}`);
        }
    }
    AuthService.prototype.loginWithRedirect = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = window.location;
                        return [4 /*yield*/, this.buildAuthorizeUrl(options)];
                    case 1:
                        _a.href = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.buildAuthorizeUrl = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var instance, authUrl, serviceAddresses, state, nonce, codeVerifier, codeChallengeBuffer, codeChallenge, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        instance = typedi_1.Container.get('instance');
                        authUrl = options.authorizeUrl;
                        if (!!options.authorizeUrl) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.sdsService.getAllServiceAddresses()];
                    case 1:
                        serviceAddresses = _a.sent();
                        authUrl = serviceAddresses.auth + "/tenants/" + (options.tenant || instance.getSubdomain());
                        _a.label = 2;
                    case 2:
                        state = options.state || window.btoa(this.cryptoService.createRandomString());
                        nonce = options.nonce || window.btoa(this.cryptoService.createRandomString());
                        codeVerifier = this.cryptoService.createRandomString();
                        return [4 /*yield*/, this.cryptoService.sha256(codeVerifier)];
                    case 3:
                        codeChallengeBuffer = _a.sent();
                        codeChallenge = bufferToBase64UrlEncoded_1.bufferToBase64UrlEncoded(codeChallengeBuffer);
                        this.localStorageService.setItem(CODE_VERIFIER_LOCAL_STORAGE_KEY, codeVerifier);
                        url = authUrl + "/connect/authorize?" + this.urlService.objectToQueryParams({
                            client_id: options.clientId || instance.getClientId(),
                            grant_type: options.grantType || 'authorization_code',
                            redirect_uri: options.redirectUri,
                            response_type: options.responseMode || 'code',
                            scope: options.scope,
                            response_mode: options.responseMode || 'query',
                            state: state,
                            nonce: nonce,
                            code_challenge: codeChallenge,
                            code_challenge_method: 'S256',
                        });
                        return [2 /*return*/, url];
                }
            });
        });
    };
    AuthService.prototype.isAuthenticated = function () {
        return !!this.token;
    };
    AuthService.prototype.getAccessToken = function () {
        return this.token;
    };
    AuthService.prototype.getPayload = function () {
        var _a;
        if (!this.isAuthenticated()) {
            return;
        }
        else {
            return getParsedJwt_1.getParsedJwt((_a = this.token) === null || _a === void 0 ? void 0 : _a.replace('Bearer', ''));
        }
    };
    AuthService.prototype.getOpenIdConfiguration = function () {
        return __awaiter(this, void 0, void 0, function () {
            var instance, sdsAddresses, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        instance = typedi_1.Container.get('instance');
                        return [4 /*yield*/, this.sdsService.getAllServiceAddresses()];
                    case 1:
                        sdsAddresses = _a.sent();
                        url = sdsAddresses.auth + "/tenants/" + instance.getSubdomain() + "/.well-known/openid-configuration";
                        return [2 /*return*/, this.httpService.get(url)];
                }
            });
        });
    };
    AuthService.prototype.getUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var instance, sdsAddresses;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        instance = typedi_1.Container.get('instance');
                        return [4 /*yield*/, this.sdsService.getAllServiceAddresses()];
                    case 1:
                        sdsAddresses = _a.sent();
                        return [2 /*return*/, this.httpService.get(sdsAddresses.auth + "/tenants/" + instance.getSubdomain() + "/connect/token")];
                }
            });
        });
    };
    /**
     * Exchanges authorization code for access token by making call to {AUTH_API_URL}/tenants/{TENANT}/connect/token
     */
    AuthService.prototype.getToken = function (code, redirectUri) {
        return __awaiter(this, void 0, void 0, function () {
            var instance, sdsAddresses, codeVerifier, res, accessToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        instance = typedi_1.Container.get('instance');
                        return [4 /*yield*/, this.sdsService.getAllServiceAddresses()];
                    case 1:
                        sdsAddresses = _a.sent();
                        codeVerifier = this.localStorageService.getItem(CODE_VERIFIER_LOCAL_STORAGE_KEY);
                        return [4 /*yield*/, this.httpService.post(sdsAddresses.auth + "/tenants/" + instance.getSubdomain() + "/connect/token", {
                                grant_type: 'authorization_code',
                                code: code,
                                redirect_uri: redirectUri,
                                code_verifier: codeVerifier,
                                client_id: instance.getClientId(),
                            }, {
                                ignoreGlobalHeaders: true,
                                headers: {
                                    Accept: '*/*',
                                    'Cache-Control': 'no-cache',
                                    Authorization: "Basic " + window.btoa(instance.getClientId() + ':'),
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                },
                            })];
                    case 2:
                        res = _a.sent();
                        accessToken = res.token_type + " " + res.access_token;
                        this.localStorageService.setItem(ACCESS_TOKEN_STORAGE_KEY, accessToken);
                        this.token = accessToken;
                        this.onTokenGrantedSubject.next(res);
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     * @private
     */
    AuthService.prototype.intercept = function (request, next) {
        if (!this.isAuthenticated()) {
            return next.handle(request);
        }
        else {
            return next.handle(request.clone({
                headers: {
                    authorization: this.token,
                },
            }));
        }
    };
    AuthService = __decorate([
        CommonService_decorator_1.CommonService('AuthService', { alwaysInitialized: true }),
        __metadata("design:paramtypes", [ServiceAddress_service_1.ServiceAddressService,
            BaseUserService_1.BaseUserService,
            Url_service_1.UrlService,
            Crypto_service_1.CryptoService,
            Http_service_1.HttpService,
            LocalStorage_service_1.LocalStorageService])
    ], AuthService);
    return AuthService;
}());
exports.AuthService = AuthService;
//# sourceMappingURL=Auth.service.js.map